<template>
  <div class="panel-body">
    <div v-if="loading" class="loading fullheight" id="loader">
      <div class="lds-dual-ring"></div>
    </div>
    <label class="mt-4"><span class="label">Data lotto</span></label>
    <p id="codice-lotto" class="codice-lotto mt-1">{{setData}}</p>
    <vue-form-generator :schema="schema" :model="model" :options="formOptions"></vue-form-generator>
          <p>{{this.msg_conferma}}</p>
          <p v-if="this.msg_trasformation_record">{{this.msg_trasformation_record}}</p>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
export default {
  name: 'trasformazione',
  components: {},
  data() {
    return {
      apiUrl: process.env.VUE_APP_ROOT_API,
      config: {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('access_token')
        }
      },
      loading: false,
      msg_conferma: '',
      msg_trasformation_record: '',
      model: {
        batch_code: '',
        batch_date: '',
        batch_raws: [],
        phosphatase: false,
        Data_maturazione: '',
        Start_trasformazione: '',
        End_trasformazione: '',
        fat: '',
        ecoli: false,
        coilform: false,
        humidity: ''
      },
      schema: {
        fields: [{
            type: 'input',
            inputType: 'string',
            label: 'Codice del lotto',
            model: 'batch_code',
            placeholder: 'Inserire codice lotto',
            required: true
          },
          {
            type: 'vueMultiSelect',
            label: 'Lotti Materia Prima',
            model: 'batch_raws',
            placeholder: "Selezionare i lotti MP",
            selectOptions: {
              optionsLimit: 10,
              multiple: true,
              key: 'name',
              label: 'name',
              trackBy: 'name',
              searchable: false,
              closeOnSelect: false,
              clearOnSelect: false,
              allowEmpty: true,
              hideSelected: true,
              showLabels: true
            },
            values: [],
            required: true
          },
          {
            type: 'input',
            inputType: 'date',
            label: 'Start Trasformazione',
            model: 'Start_trasformazione',
            required: true,
            placeholder: 'inserisci data inizio trasformazione'
          },
          {
            type: 'input',
            inputType: 'date',
            label: 'End Trasformazione',
            model: 'End_trasformazione',
            required: true,
            placeholder: 'inserisci data inizio trasformazione'
          },
          {
            type: 'checkbox',
            label: 'Fosfatasi',
            model: 'phosphatase',
            default: false
          },
          {
            type: 'input',
            inputType: 'date',
            label: 'Data Maturazione',
            model: 'Data_maturazione',
            required: true,
            placeholder: 'inserisci data maturazione'
          },
          {
            type: 'input',
            inputType: 'number',
            label: 'Umidità',
            model: 'humidity',
            required: true
          },
          {
            type: 'input',
            inputType: 'number',
            label: 'Grasso',
            model: 'fat',
            required: true
          },
          {
            type: 'checkbox',
            label: 'Escherichia coli',
            model: 'ecoli',
            default: false
          },
          {
            type: 'checkbox',
            label: 'Coliformi',
            model: 'coilform',
            default: false
          },
          {
            type: 'submit',
            buttonText: 'Invia',
            validateBeforeSubmit: true,
            onSubmit: this.saveForm,
            disabled: false
          }
        ]
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: false,
        validateAsync: false
      }
    }
  },
  mounted() {
    this.getrawmplist()
  },
  methods: {
    dateFromDay(year, day) {
      const options = {
        'year': 'numeric',
        'month': '2-digit',
        'day': '2-digit'
      };
      const date = new Date(year, 0);
      const _data = new Date(date.setDate(day)).toLocaleString('it-IT', options);
      return _data;
    },
    saveForm: function (model) {
      this.loading = true
      this.$store.dispatch('update_trasformazione', model)
      this.setTrasformazione()
      // eslint-disable-next-line 
      //console.log("invio dati in post")
    },
    nextStep: function () {
      this.second = false
    },
    setTrasformazione: function () {
      if (!this.model.batch_code || !this.model.batch_raws.length || !this.model.Start_trasformazione || !this.model.End_trasformazione || !this.model.Data_maturazione || !this.model.humidity || !this.model.fat) {
        this.msg_trasformation_record = 'Compila tutti i campi e riprova'
        this.loading = false
      } else {
        axios.get(this.apiUrl + 'products?code=' + this.model.batch_code, this.config)
          .then((response) => {
            if (response.data.length != 0) {
              // console.log("returning true")
              this.msg_conferma = 'Hai già inserito le informazioni per questo lotto.'
              this.loading = false
            } else {
              // console.log("returning false")
              this.msg_transformation_record = ''
              let batch_raws_only_id = []
              var batch_raws = this.model.batch_raws
              for (let r of batch_raws) {
                batch_raws_only_id.push(r.id)
              }
              // eslint-disable-next-line     
              //console.log("batch_date",this.model.Data_maturatione)
              var maturation = new Date(this.model.Data_maturazione)
              var month = ("0" + (maturation.getMonth() + 1)).slice(-2)
              var day = ("0" + (maturation.getDate())).slice(-2)
              var year = (maturation.getFullYear())
              let maturation_formatted = year + "-" + month + "-" + day + " 10:00:00"

              var start_trasf = new Date(this.model.Start_trasformazione)
              month = ("0" + (start_trasf.getMonth() + 1)).slice(-2)
              day = ("0" + (start_trasf.getDate())).slice(-2)
              year = (start_trasf.getFullYear())
              let start_trasformazione = year + "-" + month + "-" + day + " 10:00:00"

              var end_trasf = new Date(this.model.End_trasformazione)
              month = ("0" + (end_trasf.getMonth() + 1)).slice(-2)
              day = ("0" + (end_trasf.getDate())).slice(-2)
              year = (end_trasf.getFullYear())
              let end_trasformazione = year + "-" + month + "-" + day + " 10:00:00"

              axios.post(this.apiUrl + 'products', {
                  "batchraws": batch_raws_only_id,
                  "code": this.model.batch_code,
                  "maturation": maturation_formatted,
                  "start_transformation": start_trasformazione,
                  "end_transformation": end_trasformazione,
                  "firming": this.model.Rassodamento,
                  "humidity": this.model.humidity,
                  "fat": this.model.fat,
                  "ecoli": this.model.ecoli,
                  "coliform": this.model.coilform,
                  "phosphatase": this.model.phosphatase,
                  "productowner": 1
                }, this.config

              ).then(() => {
                // eslint-disable-next-line
                // console.log(response.data)
                this.msg_conferma = 'Informazioni registrate correttamente'
                this.sent = true
                this.schema.fields[9].disabled = true
              }).catch((error) => {
                // eslint-disable-next-line
                console.log(error)
                this.msg_conferma = 'Si è verificato un errore, riprova'
              }).finally(() => {
                this.loading = false
              });
            }
          })
          .catch(() => {
            return false
          })
        // eslint-disable-next-line
        //console.log("Getting data:", batch_values)
      }
    },
    getrawmplist: function () {
      this.loading = true
      axios.get(this.apiUrl + 'batchraws?_sort=created_at:DESC', this.config)
        .then(response => {
          let rawmpbatch_values = []
          for (let r of response.data) {
            rawmpbatch_values.push({
              "name": r.code,
              "id": r.id,

            })
          }
          this.$store.commit('RAWMPLIST_FETCH', rawmpbatch_values)
          this.schema.fields[1].values = rawmpbatch_values
          this.loading = false
        })
    },
    computed: {
      setData() {
        let year;
        let day;
        let lotto = this.model.batch_code;
        // eslint-disable-next-line
        //console.log("lotto",this.lotto)
        const stringLength = lotto.length;
        if (stringLength === 4) {
          year = '202' + lotto.substring(0, 1);
          // eslint-disable-next-line
          //console.log("year",year)
          day = lotto.substring(1, 4);
          // eslint-disable-next-line
          //console.log("day",day)
        } else if (stringLength === 5) {
          year = '20' + lotto.substring(0, 2);
          // eslint-disable-next-line
          //console.log("year",year)
          day = lotto.substring(2, 5);
          // eslint-disable-next-line
          //console.log("day",day)
        } else {
          return null
        }
        return this.dateFromDay(year, day);
      },
    }
  }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>


.codice-lotto{
  font-weight: bold;
  color: #300;
}
</style>
